import { configureStore } from "@reduxjs/toolkit";

import AdminSlice from "./Admins/AdminsSlice";

export const store = configureStore({
  reducer: {
    admins: AdminSlice,
  },
});

// Define RootState type
export type RootState = ReturnType<typeof store.getState>;

// Export the store type for use with dispatch
export type AppDispatch = typeof store.dispatch;
